import { useThemeContext } from 'contexts';
import { isThemeExpInService } from 'utils/tenant/which-tenant';
import { SEARCH_OPTION_MILITARY_BASE, SEARCH_OPTION_IN_SERVICE } from 'themes/themeConfig';
import type { SearchOptions as SearchOptionTypes } from 'themes/themeConfig';

/**
 * Hook to determine which search options to use based on tenant configuration.
 * 
 * This hook applies tenant-specific search strategies. For in-service tenants,
 * it automatically applies the InServiceSearchStrategy which includes military base results.
 * For other tenants, it uses the provided search option.
 * 
 * @param baseSearchOption The base search option provided to the component
 * @returns The effective search option to use for the current tenant
 */
export function useSearchOptions(
  baseSearchOption?: SearchOptionTypes
): SearchOptionTypes | undefined {
  const { themeName } = useThemeContext();
  
  // For In-Service tenant, use InService strategy that includes military bases
  // This ensures we search for both regular locations and military bases
  const isInServiceTenant = isThemeExpInService(themeName);
  if (isInServiceTenant) {
    return SEARCH_OPTION_IN_SERVICE;
  }  
  
  // For all other tenants, use the provided base search option
  return baseSearchOption;
} 